import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pin-input-component" }
const _hoisted_2 = { class: "flex gap-4 mb-7" }
const _hoisted_3 = ["id", "onUpdate:modelValue", "onInput", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pinCode, (digit, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("input", {
          key: index,
          type: "text",
          class: "form-control-code",
          id: `${_ctx.inputId}-${index}`,
          "onUpdate:modelValue": ($event: any) => ((_ctx.pinCode[index]) = $event),
          maxlength: "1",
          onInput: ($event: any) => (_ctx.handleInput(index, $event)),
          onKeydown: ($event: any) => (_ctx.handleKeydown(index, $event)),
          onPaste: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
          placeholder: "",
          inputmode: "numeric",
          pattern: "[0-9]"
        }, null, 40, _hoisted_3)), [
          [_vModelText, _ctx.pinCode[index]]
        ])
      }), 128))
    ])
  ]))
}